import * as React from "react";

import { FormattedMessage, FormattedPlural } from "react-intl";
import { useIntl } from "common/intl/helpers";
const styles = require("./listTitle.scss");

interface IProps {
  titleId: string | null;
  pluralTitleId?: string;
  count?: number;
  showZero?: boolean;
}

const ListTitle = ({ titleId, pluralTitleId, count, showZero }: IProps) => {
  const intl = useIntl();
  if (!titleId) return null;
  if (!count && count !== 0) {
    return (
      <span className={styles.listTitle}>
        <FormattedMessage id={titleId} />
      </span>
    );
  }
  return (
    <span className={styles.listTitle}>
      {count > 0 ? (
        <FormattedPlural
          value={count}
          one={
            <span
              dangerouslySetInnerHTML={{
                __html: intl.formatMessage(
                  {
                    id: titleId,
                  },
                  {
                    count: `<span class="${styles.count}">${intl.formatNumber(
                      count,
                    )}</span>`,
                  },
                ),
              }}
            />
          }
          other={
            <span
              dangerouslySetInnerHTML={{
                __html: intl.formatMessage(
                  {
                    id: pluralTitleId ? pluralTitleId : titleId,
                  },
                  {
                    count: `<span class="${styles.count}">${intl.formatNumber(
                      count,
                    )}</span>`,
                  },
                ),
              }}
            />
          }
        />
      ) : showZero ? (
        <span
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage(
              {
                id: titleId,
              },
              {
                count: `<span class="${styles.count}">${intl.formatNumber(
                  count,
                )}</span>`,
              },
            ),
          }}
        />
      ) : (
        <FormattedMessage id={titleId} values={{ count: "" }} />
      )}
    </span>
  );
};

export default ListTitle;
